import { newBlob } from "@/store/audio-capture/audio-capture-error-handling-helpers";
import { DesktopAudioAssembler } from "@/store/audio-capture/desktop/capture/desktop-audio-assembler";
import {
  DESKTOP_PCM_SAMPLE_RATE,
  isDesktopPcmBlob,
} from "@/store/audio-capture/desktop/capture/desktop-pcm-persistence";

export async function assembleAudioBlobFromChunks(chunks: Blob[]): Promise<Blob | null> {
  if (chunks.length === 0) return null;

  if (chunks.some(isDesktopPcmBlob)) {
    const pcmChunks = chunks.filter(isDesktopPcmBlob);
    if (pcmChunks.length === 0) return null;

    return DesktopAudioAssembler.createWavFromPcmBlobs(pcmChunks, DESKTOP_PCM_SAMPLE_RATE);
  }

  const firstChunk = chunks[0];
  const blob = newBlob(chunks, { type: firstChunk?.type ?? "audio/webm" });
  return blob ?? null;
}
